module.exports = __webpack_public_path__ + "static/media/andrew@3x.fe447b4d.png";